import * as React from 'react';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import PageSectionTwoColumns from 'components/page-section-two-columns/page-section-two-columns';
import TextSection, { TextSectionTitleStyle } from 'components/text-section/text-section';
import ColumnMediaCard from 'components/column-media-card/column-media-card';
import ColumnMediaCardWrapper from 'components/column-media-card/column-media-card-wrapper';
import { MobileCaption } from 'components/typography';

export type PageLifeSectionProps = {
    caption?: string;
    title: string;
    text: string;
    extraText?: string;
    imageSrc: string;
    imageAspectRatio?: number;
    imagePosition?: 'left' | 'right';
    mediaquery?: MediaQueryWidth;
    brand?: 'bumble' | 'badoo';
    ctaLink?: string;
    ctaText?: string;
    ctaTextTwo?: string;
    ctaLinkTwo?: string;
};

const PageLifeSection: React.FC<PageLifeSectionProps> = (props) => {
    const {
        caption,
        title,
        text,
        ctaLink,
        ctaText,
        ctaTextTwo,
        ctaLinkTwo,
        extraText,
        imageSrc,
        imagePosition = 'left',
        mediaquery = 640,
        brand = 'bumble',
    } = props;

    const isBreakpoint = useMediaQuery(mediaquery);
    const imageAspectRatio = 536 / 670;

    const textBlock = (
        <TextSection
            caption={isBreakpoint ? undefined : caption}
            titleStyle={TextSectionTitleStyle.H2}
            titleCenter={isBreakpoint}
            title={title}
            text={text}
            extraText={extraText}
            ctaLink={ctaLink}
            ctaText={ctaText}
            ctaTextTwo={ctaTextTwo}
            ctaLinkTwo={ctaLinkTwo}
        />
    );

    const imageBlock = (
        <>
            {isBreakpoint && caption ? <MobileCaption>{caption}</MobileCaption> : null}
            <ColumnMediaCardWrapper maxWidth="585px">
                <ColumnMediaCard
                    hasShadow={true}
                    src={imageSrc}
                    aspectRatio={imageAspectRatio}
                    // @TODO make it as prop to show text over image
                    // title={isBreakpoint ? title : undefined}
                />
            </ColumnMediaCardWrapper>
        </>
    );

    return (
        <PageSectionTwoColumns
            extraClass={`page__section--padded ${brand}`}
            isMobileOrderInverted={imagePosition === 'right'}
            right={textBlock}
            left={imageBlock}
        />
    );
};

export default PageLifeSection;
